import { render } from "./PosterPublications.vue?vue&type=template&id=b7d07c8c"
import script from "./PosterPublications.vue?vue&type=script&lang=js"
export * from "./PosterPublications.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__